import {
  LAUNCH_CALENDAR_CARD_CLICK,
  LAUNCH_CALENDAR_PAGE_VIEW,
  LAUNCH_CALENDAR_SECTION_CLICK,
  LAUNCH_CALENDAR_SUBSCRIPTION_CLICK
} from 'constants/amethyst';

export const LAUNCH_CALENDAR_FLOW_TYPE = {
  UnknownFlowType: 'UNKNOWN_FLOW_TYPE',
  NotifyMeModal: 'NOTIFY_ME_MODAL',
  UpcomingStyleModal: 'UPCOMING_STYLE_MODAL',
  ProductDetailPage: 'PRODUCT_DETAIL_PAGE'
};

export const LAUNCH_CALENDAR_SECTION_TYPE = {
  UpcomingLaunches: 'UPCOMING_LAUNCHES',
  RecentLaunches: 'RECENT_LAUNCHES'
};

type ProductCardInteractParams = {
  flowType: string;
  styleId: number;
};

type LaunchCalendarPageViewParams = {
  itemsFound: number;
};

type LaunchCalendarSectionClickParams = {
  sectionType: string;
  itemsFound: number;
};

type LaunchCalendarSubscriptionClickParams = {
  flowType: string;
  isItemSetupCompleted: boolean;
  styleId: number;
};
export const evProductCardInteract = ({ flowType, styleId }: ProductCardInteractParams) => ({
  [LAUNCH_CALENDAR_CARD_CLICK]: {
    flowType,
    styleId
  }
});

export const evLaunchCalendarPageView = ({ itemsFound }: LaunchCalendarPageViewParams) => ({
  [LAUNCH_CALENDAR_PAGE_VIEW]: {
    itemsFound
  }
});

export const evLaunchCalendarSectionClick = ({ sectionType, itemsFound }: LaunchCalendarSectionClickParams) => ({
  [LAUNCH_CALENDAR_SECTION_CLICK]: {
    sectionType,
    itemsFound
  }
});

export const evLaunchCalendarSubscriptionClick = ({ flowType, isItemSetupCompleted, styleId }: LaunchCalendarSubscriptionClickParams) => ({
  [LAUNCH_CALENDAR_SUBSCRIPTION_CLICK]: {
    flowType,
    isItemSetupCompleted,
    styleId
  }
});
